import { PlanCheckoutKeys } from '../../../../consts';
import { useGetExpectPlanPrice } from '../../../../services';
import { PlanProduct } from '../../../../types';

interface UseExpectedPlanPriceParams {
  spaceHashId: string;
  selectedPlanInfo: PlanProduct;
  enabled: boolean;
}

interface ExpectedPlanPriceResult {
  미사용금액: number;
  추가결제예상금액: number;
  unusedDayCount: number;
  originalPrice: number;
  vatAmount: number;
}

export const useExpectedPlanPrice = ({
  spaceHashId,
  selectedPlanInfo,
  enabled,
}: UseExpectedPlanPriceParams): ExpectedPlanPriceResult => {
  const { data: expectedPriceRes } = useGetExpectPlanPrice(
    spaceHashId,
    selectedPlanInfo?.id ?? 0,
    {
      enabled,
      queryKey: [
        ...PlanCheckoutKeys.ExpectedPrice(spaceHashId, selectedPlanInfo.id),
      ],
      placeholderData: () => {
        return {
          data: {
            isUpgrade: false,
            asisPlanId: 0,
            spacePlanTemplateId: selectedPlanInfo.id,
            saleType: selectedPlanInfo.saleType ?? '',
            salePrice: 0,
            unusedPrice: 0,
            unusedDayCount: 0,
            saleDiscountPrice: selectedPlanInfo.saleDiscountPrice,
            totalDiscountPrice: selectedPlanInfo.saleDiscountPrice,
            finalPrice: selectedPlanInfo.saleType
              ? selectedPlanInfo.salePrice
              : selectedPlanInfo.originalPrice,
            originalPrice: selectedPlanInfo.originalPrice,
            vatAmount: 0,
            vatRate: 0,
            priceBeforeVat: 0,
          },
          status: 0,
        };
      },
    },
  );

  const {
    unusedPrice: 미사용금액,
    finalPrice: 추가결제예상금액,
    unusedDayCount,
    originalPrice,
    vatAmount,
  } = expectedPriceRes.data;

  return {
    미사용금액,
    추가결제예상금액,
    unusedDayCount,
    originalPrice,
    vatAmount,
  };
};
